import clsx from 'clsx';

import {
  createWidgetForChildNode,
  ObjectPropertiesProps,
} from './ObjectProperties';

import styles from './objectWidget.module.scss';

export function ColumnFormatObjectProperties({
  node,
  options,
  editor,
}: ObjectPropertiesProps) {
  return (
    <div
      className={clsx('rje-object__properties', styles['column-item'])}
      style={{ boxShadow: 'none', border: 0 }}
    >
      {node.children
        .filter((c) => !c.options.hidden)
        .map((child) => (
          <div key={child.id}>
            {createWidgetForChildNode(node, options, child, editor)}
          </div>
        ))}
    </div>
  );
}
